module.exports = __webpack_public_path__ + "img/image8.145c4263.jpg";